import SurveyHttp from '../../http';
import SurveyViewModel from '../../view-models/survey-view-model';


const GetSurveyUseCase = {
  async execute(payload) {
    try {
      const surveyByTypeResponse = await SurveyHttp.getSurveyByType(payload);

      const surveyFormResponse = await SurveyHttp.getSurveyById(surveyByTypeResponse);

      return surveyFormResponse.isActive
        ? SurveyViewModel.create(surveyFormResponse)
        : null;
    }
    catch (e) {
      throw e;
    }
  }
};

export default GetSurveyUseCase;
